<script>
import VideoPlayer from "../../component/VideoPlayer.vue";
export default {
  name: "rocketsvg",
  components: {
    VideoPlayer,
  },
  data() {
    return {
      smokeURL: require("../../assets/images/smoke.png"),
    };
  },
  updated() {
    this.drawSmoke();
  },
  mounted() {
    let smokeImg = new Image();
    smokeImg.src = this.smokeURL;
    this.drawSmoke();
  },
  methods: {
    drawSmoke() {
      (function () {
        var requestAnimationFrame =
          window.requestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.msRequestAnimationFrame;
        window.requestAnimationFrame = requestAnimationFrame;
      })();
      var canvas = document.getElementById("smoke_canvas"),
        ctx = canvas.getContext("2d"),
        loading = true;
      canvas.height = document.body.clientHeight;
      canvas.width = document.body.clientWidth;

      var parts = [],
        minSpawnTime = 15, //間隔時間
        lastTime = new Date().getTime(),
        maxLifeTime = (canvas.height / (1.5 * 60)) * 1000,
        emitterX = canvas.width / 2, //clientWidth的一半
        emitterY = canvas.height - 10, //clientHeight-10
        smokeImage = new Image();

      function spawn() {
        if (new Date().getTime() > lastTime + minSpawnTime) {
          //最後執行時間+間隔minSpawnTime後執行
          lastTime = new Date().getTime(); //lastTime=最後執行時間
          if (parts.length > 200) {
            //parts只存200筆
            parts.splice(0, 1);
          }
          parts.push(new smoke(emitterX, emitterY));
        }
      }
      function render() {
        if (loading) {
          //跳出等待loading再render
          load();
          return false;
        }

        var len = parts.length;
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        while (len--) {
          parts[len].update();

          ctx.save();
          var offsetX = -parts[len].size / 3,
            offsetY = -parts[len].size / 3;

          ctx.translate(parts[len].x, parts[len].y);
          ctx.rotate((parts[len].angle / 180) * Math.PI);
          ctx.globalAlpha = parts[len].alpha;
          ctx.drawImage(
            smokeImage,
            offsetX,
            offsetY,
            parts[len].size,
            parts[len].size
          );
          ctx.restore();
        }
        spawn();
        requestAnimationFrame(render);
      }

      function smoke(x, y) {
        this.x = x; //clientWidth的一半
        this.y = y; //clientHeight-10

        this.size = 3;
        this.startSize = 55;
        this.endSize = 80;

        this.angle = Math.random() * 359;

        this.startLife = new Date().getTime();
        this.lifeTime = 0;

        this.velY = -1 - Math.random();
        this.velX = Math.floor(Math.random() * -6 + 3) / 2;
      }

      smoke.prototype.update = function () {
        this.lifeTime = Math.max(1000, new Date().getTime() - this.startLife);
        this.angle += 0.2;

        var lifePerc = (this.lifeTime / maxLifeTime) * 450;

        this.size =
          this.startSize + (this.endSize - this.startSize) * lifePerc * 0.1;

        this.alpha = 1 - lifePerc * 0.01;
        this.alpha = Math.max(this.alpha, 0);

        this.x += this.velX;
        this.y += this.velY;
      };

      smokeImage.src = document.querySelector(".smoke_img").src;
      smokeImage.onload = function () {
        loading = false;
      };

      function load() {
        //等待loading結束render
        if (loading) {
          setTimeout(load, 50);
        } else {
          render();
        }
      }
      render();

      window.onresize = resizeMe; //resize
      window.onload = resizeMe;
      function resizeMe() {
        canvas.height = document.body.clientHeight;
      }
    },
  },
};
</script>

<!-- 引入template.html,style.scss  -->
<template src="./template.html"></template>
<style lang="scss" src="./style.scss"></style>
